"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Issues = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type", "platform", "base", "property", "user", "repo", "label"];
var Issues = exports.Issues = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$type = props.type,
    type = _props$type === void 0 ? 'issues' : _props$type,
    _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'github' : _props$platform,
    _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    property = props.property,
    user = props.user,
    repo = props.repo,
    label = props.label,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    if (platform !== 'github') return '';
    if (type === 'issues' || /^issues-(raw|closed|closed-raw|pr|pr-raw|pr-closed|pr-closed-raw)/.test(type)) {
      if (label && (type === 'issues' || /^issues-(raw|pr|pr-raw)/.test(type || ''))) {
        return [base, platform, type, user, repo, label].join('/');
      }
      return [base, platform, type, user, repo].join('/');
    }
    if (type === 'issueKind') {
      return [base, platform, type, 'detail', property, user, repo].join('/');
    }
    return '';
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Issues.displayName = 'Issues';